import { ReactNode } from 'react'
import { useCompanyStore } from '../../store/company/companyStore'
import { Button, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
const { Text } = Typography

export const PaidBlocker = ({
  action,
  children
}: {
  action: string
  children: ReactNode
}) => {
  const plan = useCompanyStore((state) => state.company?.plan)
  if (!plan || plan === 'free') {
    return (
      <div className="flex gap-4 items-center">
        <Text className="text-md font-semibold">Upgrade to {action}</Text>
        <Link to="/app/upgrade">
          <Button type="primary">
            See plans <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    )
  }

  return <>{children}</>
}
